// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FCXz","rootMobile":"styles_rootMobile__jsaEZ"};